var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiAccountEditOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_account-edit-outline",
    "data-name": "MDI / account-edit-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_account-edit-outline",
    "data-name": "Path / account-edit-outline",
    d: "M2,17v3h8V18.11H3.9V17c0-.64,3.13-2.1,6.1-2.1a11.694,11.694,0,0,1,2.83.38l1.52-1.52A14.508,14.508,0,0,0,10,13c-2.67,0-8,1.33-8,4M10,4a4,4,0,1,0,4,4,4,4,0,0,0-4-4m0,6a2,2,0,1,1,2-2,2,2,0,0,1-2,2m11.7,3.35-1,1-2.05-2,1-1a.549.549,0,0,1,.77,0l1.28,1.28a.549.549,0,0,1,0,.77M12,18.94l6.06-6.06,2.05,2-6,6.07H12V18.94",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiAccountEditOutline);
export default __webpack_public_path__ + "static/media/MDI - account-edit-outline.e7dd2c8ef2d806af48561aa8c99177cc.svg";
export { ForwardRef as ReactComponent };